import { Patient, StudyOrg, TimeZoneId } from '@csp/csp-common-model';
import { ScheduleReferenceDates, getScheduleRequestRefsMatchingRequest, RequestRef } from '@csp/csp-common-scheduling';
import { ScheduleReferenceDateService } from '@csp/csp-common-patient-scheduling';
import { VisitRequest } from './VisitRequest';

export type VisitRequestTemplateIn = VisitRequest & {
  alreadyBookedRequests: RequestRef[];
  scheduleReferenceDates: ScheduleReferenceDates;
  timezone: TimeZoneId;
};

const from =
  (patient: Patient, studyOrg: StudyOrg, alreadyBookedRequests: RequestRef[], timezone: TimeZoneId) =>
  (request: VisitRequest): VisitRequestTemplateIn => ({
    ...request,
    scheduleReferenceDates: {
      ...ScheduleReferenceDateService.fromPatient(patient),
      orgCustomStatuses: studyOrg.getMergedOrgCustomStatuses(patient.firstOrgId ?? ''),
    },
    timezone,
    alreadyBookedRequests: getScheduleRequestRefsMatchingRequest(
      request.scheduleCode,
      request.requestCode,
      alreadyBookedRequests,
    ),
  });

export const VisitRequestTemplateIn = {
  from,
};
